export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-15.f77708db.png";